import $ from 'jquery';

export default () => {
  const container = $('.slider').eq(0);
  const slider = $('.slides', container);
  const contentBoxes = slider.find('.slide_content');

  if (slider.children().length < 2) {
    return;
  }

  slider.bxSlider({
    auto: true,
    pause: 5000,
    autoHover: true,
    controls: false,
    preloadImages: 'all',
    onSliderLoad: () => {
      checkDimensions();
      checkDescriptionHeight();
    },
    onSliderResize: function() {
      checkDimensions();
      checkDescriptionHeight();
    },
    onSlideBefore: function() {
      checkDimensions();
    },
  });

  // container.find('.bx-viewport').off('touchstart');

  slider.find('a').not('.use-ajax').click(function(event) {
    window.location.href = $(this).attr('href');
  });

  $('.next', container).click(() => slider.goToNextSlide());
  $('.prev', container).click(() => slider.goToPrevSlide());

  function checkDimensions() {
    const viewHeight = container.height();
    const viewWidth = container.width();
    const viewRatio = viewWidth / viewHeight;

    slider.find('.slide')
      .each((i, node) => {
        const slide = $(node);
        const media = slide.find('.slide--background').find('video').eq(0);
        const mediaHeight = media.height();
        const mediaWidth = media.width();
        let mediaRatio = 0;

        if (media.data('ratio')) {
          mediaRatio = media.data('ratio');
        } else {
          mediaRatio = mediaWidth / mediaHeight;
          media.data('ratio', mediaRatio);
        }

        mediaRatio < viewRatio ? slide.addClass('alt') : slide.removeClass('alt');
      });
  }

  function checkDescriptionHeight() {
    const $boxes = slider.find('.slide_content');

    $boxes.each(function() {
      const $box = $(this);
      const $desc = $box.children('.description');
      const $p = $desc.find('p');

      // Some slides might not has a description
      // so let's check it
      if ($p.length) {
        // Could happend that visible height of .description element is even
        // smaller than line-height of p element which will cause it to be shaved
        // to 0 lines. So we pick what's bigger from the line-height and maxHeight
        $p.shave(Math.max($desc.height(), parseFloat($p.css('line-height'))))
      }
    });
  }
}
